import { render, staticRenderFns } from "./DevelopHome.vue?vue&type=template&id=36956df3&scoped=true&"
import script from "./DevelopHome.vue?vue&type=script&lang=js&"
export * from "./DevelopHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36956df3",
  null
  
)

export default component.exports